import type { Segment } from '@hotjar/webapp/features/Recordings/types';

export const SEGMENTS_QUERY_KEY = 'segments';

const commonProps = {
  site_id: 0,
  created: '1970-01-01T00:00:00',
  modified: '1970-01-01T00:00:00',
  created_by_user_id: 0,
  modified_by_user_id: 0,
  read_only: true,
  unsupported_features: [],
};

export const DEFAULT_SEGMENT: Segment = {
  ...commonProps,
  id: -1, // The default segment, including all recordings from the last month
  name: 'common:dashboard.recordings-card.filter.all-users',
  filters: {
    DAYS_AGO: { created: 30 },
  },
};

const NEW_USER_SEGMENT: Segment = {
  ...commonProps,
  id: -6,
  name: 'common:dashboard.recordings-card.filter.new-users',
  filters: {
    AND: [{ DAYS_AGO: { created: 30 } }, { EQUAL: { new_user: 'true' } }],
  },
};
const RETURNING_USER_SEGMENT: Segment = {
  ...commonProps,
  id: -7,
  name: 'common:dashboard.recordings-card.filter.returning-users',
  filters: {
    AND: [{ DAYS_AGO: { created: 30 } }, { EQUAL: { new_user: 'false' } }],
  },
};
const MOBILE_USERS_SEGMENT: Segment = {
  ...commonProps,
  id: -2,
  name: 'common:dashboard.recordings-card.filter.mobile-users',
  filters: {
    AND: [{ DAYS_AGO: { created: 30 } }, { EQUAL: { device: 'phone' } }],
  },
};
const RAGE_CLICK_SEGMENT: Segment = {
  ...commonProps,
  id: -3,
  name: 'common:dashboard.recordings-card.filter.rage-clicked',
  filters: {
    AND: [{ DAYS_AGO: { created: 7 } }, { EQUAL: { rageclick: 'true' } }],
  },
};

export const ERRORS_SEGMENT_ID = -8;

const ERRORS_SEGMENT: Segment = {
  ...commonProps,
  id: ERRORS_SEGMENT_ID,
  name: 'common:dashboard.recordings-card.filter.error-occurred',
  filters: {
    AND: [{ DAYS_AGO: { created: 30 } }, { ERROR: [] }],
  },
};

// Disclaimer: Always use segments/service.ts to get them so that unsupported_features is correct
export const PREDEFINED_SEGMENTS: Segment[] = [
  DEFAULT_SEGMENT,
  NEW_USER_SEGMENT,
  RETURNING_USER_SEGMENT,
  MOBILE_USERS_SEGMENT,
  RAGE_CLICK_SEGMENT,
  ERRORS_SEGMENT,
];

// We need this type to be able to retrieve the segment from the backend
// Conceptually, a segment has no type as they will be applicable in different context (similar to the global filters)
export const LEGACY_SEGMENT_TYPE = 'recordings';
